<div class="s-wrapper">
  <img data-src="/assets/images/team/submit_res_bg.jpg" />
  <div class="send-card">
    <div class="wait">Wait!</div>
    <div class="title">Can’t find a relevant role?</div>
    <div class="divider"></div>
    <div class="subtitle">We are always looking for talent, send in your resume and we will connect with you.</div>
    <a href="https://forms.gle/cZNvebJvEcxv7i2a8" target="_blank" class="submit-action" mat-raised-button>Submit Resume</a>
  </div>
</div>